import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Pages/Shared/Footer/Footer";
import Navbar from "../Pages/Shared/Navbar/Navbar";

const Main = () => {
    // [#98A8F8] [#E9F8F9] [#DEFCF9 dark border]

    return (
        <div className="h-screen overflow-y-auto flex flex-col border-[7px] bg-slate-50 dark:bg-slate-900 border-[#98A8F8] dark:border-[#d7f8f5]">
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    );
};

export default Main;
